<template>
  <div>
    <b-modal v-model="modalShow" centered hide-header hide-footer ok-disabled cancel-disabled>
      <div class="d-block text-center modal-container">
        <div class="content">
          <div class="content-subject">{{ $t('common.check') }}</div>
          <div v-if="!isUs" class="content-desc">{{ $t('common.pleaseWait') }}</div>
          <div v-else class="content-desc">{{ $t('order.pleaseCheckout') }}</div>
          <div v-if="!isUs" class="content-notice">{{ $t('order.checkCancelDescription') }}</div>
          <div v-else class="content-notice">{{ $t('order.checkCancelDescriptionUs') }}</div>
        </div>
      </div>
      <div class="buttons">
        <b-button class="button-quit rounded-pill" @click="handleQuit">
          <img src="@/assets/images/icn_back_to_app.svg" alt />
          <span>{{ $t('selfcheck.smartphoneOrderFinished') }}</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      isCanceling: false,
    }
  },
  computed: {
    ...mapGetters({
      modalShow: 'modal/isShowingCheckingOutModal',
      seatStatus: 'seat/getSeatStatus',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  watch: {
    seatStatus(status) {
      // status: 0: 通常, 1:会計呼び出し中, 2: スタッフ呼び出し中, 3: ビッくらポン実施中
      if (status !== 1 && this.modalShow) {
        // 会計呼び出し中じゃないのに呼び出し中モーダルが出ていたら閉じる
        this.showModal(false)
      }
      if (status === 1 && !this.modalShow) {
        // 会計呼び出し中で呼び出し中モーダルが出ていなければ開く
        this.showModal(true)
      }
    },
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
      showModal: 'modal/setShowingCheckingOutModal',
    }),
    async handleQuit() {
      await this.deauth()
      this.showModal(false)

      if (this.isApp) {
        window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/home`
      } else {
        if (this.$route.path === '/') return
        this.$router.push({ path: '/' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal-container {
    margin-top: -110px;
  }
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-body {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.modal-container {
  margin-top: -110px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 36px;
    margin-bottom: 18px;
  }
  &-desc {
    font-size: 18px;
    margin-bottom: 24px;
  }
  &-notice {
    font-size: 14px;
    color: #535353;
  }
}
.buttons {
  position: absolute;
  left: 0;
  bottom: 75px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.button-quit {
  background: #d21b24 !important;
  width: 240px;
  height: 40px;
  border: none;
  font-weight: bold;

  &:hover,
  &:active {
    background-color: #d21b24 !important;
  }

  img {
    width: 18px;
    height: 18px;
    color: #fff;
    margin: -5px 8px 0 0;
  }
}
.content-notice {
  white-space: pre-wrap;
}
</style>
